import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M3 19H21V17H3V19ZM11 15H21V13H11V15ZM3 1V3H21V1H3ZM11 7H21V5H11V7ZM11 11H21V9H11V11Z" fill="black"/>
<path d="M7.85714 6H2.14286C1.82857 6 1.57143 6.25312 1.57143 6.5625C1.57143 6.87187 1.82857 7.125 2.14286 7.125H2.71429V9.9375C2.71429 10.8713 1.94857 11.625 1 11.625V12.75H4.41143V14.4375L4.98286 15L5.55429 14.4375V12.75H9V11.625C8.05143 11.625 7.28571 10.8713 7.28571 9.9375V7.125H7.85714C8.17143 7.125 8.42857 6.87187 8.42857 6.5625C8.42857 6.25312 8.17143 6 7.85714 6Z" fill="black"/>
</svg>
;
